import React, { Component } from 'react';
import { Wrapper } from 'components';
import styled from "react-emotion";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import backgroundImage from '../shared/images/banner_whybourne.png';
import userIcon from '../shared/images/icon_user2x.png';
import technologyIcon from '../shared/images/icon_technology2x.png';
import processIcon from '../shared/images/icon_process2x.png';
import analyticsIcon from '../shared/images/icon_analytics2x.png';

const ProcessFlowContainer = styled.div`
    color: ${props => (props.theme.colors.white)};
    background: url(${backgroundImage}) no-repeat;
    background-position: right top;
    background-color: ${props => (props.theme.colors.darkBlue)};
`;

const ProcessFlowHeader = styled.div`
    padding-top: 2rem;
`;

const ProcessTilesContainer = styled.div`
    display: flex;
    width: 100%;
    flex-wrap: wrap;
`;

const ProcessTile = styled.div`
    width: 25%;
    text-align: center;
    @media (max-width: ${props => props.theme.breakpoints.m}) {
        width: 50%;
    }
    @media (max-width: ${props => props.theme.breakpoints.s}) {
        width: 100%;
    }
`;

const ProcessTileContent = styled.div`
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    justify-content: start;
    strong {
        margin-bottom: 20px;
    }
    p {
        width: 100%;
        font-size: 0.8rem;
    }
`;

const ProcessIcon = styled.img`
    margin-bottom: 20px;
    width: 50px;
`;

class ProcessFlow extends Component {
    state = {}
    render() {
        return (
            <ProcessFlowContainer>
                <ProcessFlowHeader>
                    <Wrapper>
                        <h3>Why Bourne?</h3>
                    </Wrapper>
                </ProcessFlowHeader>
                <Wrapper>
                    <ProcessTilesContainer>
                        <ProcessTile>
                            <ProcessTileContent>
                                <ProcessIcon alt='User' src={userIcon} />
                                <strong>User</strong>
                                <p>We leverage empathy and research insights to understand the end user's needs in order to ensure user adoption of digital solutions.</p>
                            </ProcessTileContent>
                        </ProcessTile>
                        <ProcessTile>
                            <ProcessTileContent>
                                <ProcessIcon alt='Technology' src={technologyIcon} />
                                <strong>Technology</strong>
                                <p>Our engineering team have deep experience in cloud solutions, integration and security to deliver enterprise grade solutions.</p>
                            </ProcessTileContent>
                        </ProcessTile>
                        <ProcessTile>
                            <ProcessTileContent>
                                <ProcessIcon alt='Process' src={processIcon} />
                                <strong>Process</strong>
                                <p>We simplify business processes through the creation of the service design blueprint that aligns user touchpoints with the enterprise core.</p>
                            </ProcessTileContent>
                        </ProcessTile>
                        <ProcessTile>
                            <ProcessTileContent>
                                <ProcessIcon alt='Analytics' src={analyticsIcon} />
                                <strong>Analytics</strong>
                                <p>We capture relevant analytics to improve business processes and user experience.</p>
                            </ProcessTileContent>
                        </ProcessTile>
                    </ProcessTilesContainer>
                </Wrapper>
            </ProcessFlowContainer>
        );
    }
}

export default ProcessFlow;